import { Injectable, Inject} from '@angular/core';
import {BaseDO} from './base.model';
import {PersonEmploymentDO, PersonIdentityDO} from './';

export  class PersonDO{
    public id:Number=null;

	public titleCd:String=null;

	public firstName:String=null;

	public middleName:String=null;

	public lastName:String=null;
	
	public firstName1:String=null;
	
	public middleName1:String=null;
	
	public lastName1:String=null;
    
	public genderCd:String=null;
	
	public dateOfBirth:Date=null;

	public age:Number=null;
	
	public maritalStatusCd:String=null;
	
	public mothersMaidenName:String=null;

	public fathersName:String=null;

	public givenName:String=null;
	
	public legalName:String=null;
	
	public otherName:String=null;
	
	public countryOfBirthCd:String=null;
	
	public citizenshipCd:String=null;

	public politicalFlag:boolean=null;
	
	public convictedFlag:boolean=null;

	public height:any =null;

	public weight:any =null;
	
	public clientStatusCd:String=null;
	public  sourceOfIncomeCd:String=null;
	public personEmploymentList:PersonEmploymentDO[]=[];
	

	public  personIdentityList:PersonIdentityDO[]=[];

	public getId():Number {
		return this.id;
	}

	public setId(id:Number) {
		this.id = id;
	}

	public getTitleCd():String {
		return this.titleCd;
	}

	public setTitleCd(titleCd:String) {
		this.titleCd = titleCd;
	}

	public  getFirstName():String{
		return this.firstName;
	}

	public setFirstName(firstName:String) {
		this.firstName = firstName;
	}

	public  getMiddleName():String {
		return this.middleName;
	}

	public setMiddleName(middleName:String) {
		this.middleName = middleName;
	}

	public getLastName():String {
		return this.lastName;
	}

	public setLastName(lastName:String) {
		this.lastName = lastName;
	}

	public  getFirstName1():String {
		return this.firstName1;
	}

	public setFirstName1(firstName1:String) {
		this.firstName1 = firstName1;
	}

	public getMiddleName1():String {
		return this.middleName1;
	}

	public setMiddleName1(middleName1:String) {
		this.middleName1 = middleName1;
	}

	public getLastName1():String {
		return this.lastName1;
	}

	public  setLastName1(lastName1:String) {
		this.lastName1 = lastName1;
	}

	public getGenderCd():String {
		return this.genderCd;
	}

	public setGenderCd(genderCd:String) {
		this.genderCd = genderCd;
	}

	public getDateOfBirth():Date {
		return this.dateOfBirth;
	}

	public setDateOfBirth(dateOfBirth:Date) {
		this.dateOfBirth = dateOfBirth;
	}

	public  getAge():Number {
		return this.age;
	}

	public setAge(age:Number) {
		this.age = age;
	}
	public getMaritalStatusCd():String {
		return this.maritalStatusCd;
	}

	public setMaritalStatusCd(maritalStatusCd:String) {
		this.maritalStatusCd = maritalStatusCd;
	}

	public getMothersMaidenName():String{
		return this.mothersMaidenName;
	}

	public setMothersMaidenName(mothersMaidenName:String) {
		this.mothersMaidenName = mothersMaidenName;
	}

	public  getFathersName():String {
		return this.fathersName;
	}

	public setFathersName(fathersName:String) {
		this.fathersName = fathersName;
	}

	public  getGivenName():String {
		return this.givenName;
	}

	public setGivenName(givenName:String) {
		this.givenName = givenName;
	}

	public  getLegalName():String {
		return this.legalName;
	}

	public setLegalName(legalName:String) {
		this.legalName = legalName;
	}

	public  getOtherName():String {
		return this.otherName;
	}

	public setOtherName(otherName:String) {
		this.otherName = otherName;
	}

	public  getCountryOfBirthCd():String {
		return this.countryOfBirthCd;
	}

	public setCountryOfBirthCd(countryOfBirthCd:String) {
		this.countryOfBirthCd = countryOfBirthCd;
	}

	public  getCitizenshipCd():String {
		return this.citizenshipCd;
	}

	public setCitizenshipCd(citizenshipCd:String) {
		this.citizenshipCd = citizenshipCd;
	}

	public  getClientStatusCd():String {
		return this.clientStatusCd;
	}

	public setClientStatusCd(clientStatusCd:String) {
		this.clientStatusCd = clientStatusCd;
	}
	public getSourceOfIncomeCd():String {
		return this.sourceOfIncomeCd;
	}

	public setSourceOfIncomeCd(sourceOfIncomeCd:String) {
		this.sourceOfIncomeCd = sourceOfIncomeCd;
	}


	public getPersonEmploymentList():PersonEmploymentDO[] {
		return this.personEmploymentList;
	}

	public setPersonEmploymentList(personEmploymentList:PersonEmploymentDO[]) {
		this.personEmploymentList = personEmploymentList;
	}

	public getPersonIdentityList():PersonIdentityDO[] {
		return this.personIdentityList;
	}

	public setPersonIdentityList(personIdentityList:PersonIdentityDO[]) {
		this.personIdentityList = personIdentityList;
	}


	public  getPoliticalFlag():boolean {
		return this.politicalFlag;
	}

	public setPoliticalFlag(politicalFlag:boolean) {
		this.politicalFlag = politicalFlag;
	}

	public getConvictedFlag():boolean {
		return this.convictedFlag;
	}

	public setConvictedFlag(convictedFlag:boolean) {
		this.convictedFlag = convictedFlag;
	}


	

}